import React, { useEffect, useRef, useState } from "react";
import { TopButs } from "./TopButs";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { SystemFormBox } from "./SystemFormBox";
import { useDtpDetailModel } from './dtpDetailModel'


export const AgreementDetails = () => {
    const { fileVisible, setFileVisible } = useDtpDetailModel()
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const formRef = useRef<IYhFormRef>();
    useEffect(() => {
        if (detailsInfo.mode === 'add') {
            setFileVisible(false)
        } else {
            setFileVisible(true)
        }
    }, [fileVisible])
    return (
        <>
            {detailsInfo && <>
                <TopButs formRef={formRef} {...detailsInfo} />
                <FormBox formRef={formRef} {...detailsInfo} />
                {fileVisible && <TableBox {...detailsInfo} />}
                <SystemFormBox {...detailsInfo} />
            </>
            }
        </>
    )
}